(() => {
  // Ocultar también bloques creados por otra copia del script del tema.
  const giftStyle = document.getElementById('nv-hide-cart-gift-block') || document.createElement('style');
  giftStyle.id = 'nv-hide-cart-gift-block';
  giftStyle.textContent = `
    cart-drawer [data-nv-wellness-gift],
    cart-drawer div:has(> .nv-gift-switch) {
      display: none !important;
      visibility: hidden !important;
      height: 0 !important;
      min-height: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      border: 0 !important;
    }
  `;
  giftStyle.textContent += `cart-drawer .drawer__footer [data-nv-trust]{border-top:1px solid #dedede!important}`;
  giftStyle.textContent += `cart-drawer .cart-item .discounts{display:none!important;margin:0!important;padding:0!important}`;
  // Evitar la doble línea pegada al upsell en las ofertas 1 y 2.
  giftStyle.textContent += `
    cart-drawer .cart-items .cart-item[data-nv-product][data-nv-pack-level="1"],
    cart-drawer .cart-items .cart-item[data-nv-product][data-nv-pack-level="2"] {
      border-bottom: 0 !important;
      padding-bottom: 10px !important;
    }
    cart-drawer .cart-items .cart-item[data-nv-product][data-nv-pack-level="1"] + .cart-item[data-nv-gift-native],
    cart-drawer .cart-items .cart-item[data-nv-product][data-nv-pack-level="2"] + .cart-item[data-nv-gift-native] {
      border-top: 0 !important;
    }
  `;
  if (!giftStyle.isConnected) document.head.appendChild(giftStyle);
if (customElements.get('cart-drawer') && customElements.get('cart-drawer-items')) return;
class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.timerEnd = null;
    this.timerInterval = null;
    this.reservationWasOpen = false;
    this.openTimeout = null;
    this.focusTransitionHandler = null;

    this.nvProtectionId = 67785786949844;
    this.nvProtectionEnabled = false;
    this.nvWellnessId = 67795740295380;
    this.nvOldWellnessId = 67795738624212;
    this.nvWellnessProductPath = "/products/pack-bienestar-nurevia-2-guias.js";
    this.nvWellnessEnabled = false;
    try { this.nvWellnessEnabled = sessionStorage.getItem('nv-wellness-gift') === 'on'; } catch (_) {}
    this.addEventListener('change', event => {
      if (!event.target.matches('[data-nv-wellness-toggle]')) return;
      event.stopImmediatePropagation();
      if (this.nvCheckoutBusy) { event.target.checked = this.nvWellnessEnabled; return; }
      this.nvGiftRevision = (this.nvGiftRevision || 0) + 1;
      this.nvWellnessEnabled = event.target.checked;
      try { sessionStorage.setItem('nv-wellness-gift', this.nvWellnessEnabled ? 'on' : 'off'); } catch (_) {}
      this.nvProtectionSignature = null;
      clearTimeout(this.nvProtectionTimer);
      this.nvSyncProtection();
    }, true);
    this.nvCheckoutClickHandler = event => {
      const button = event.target.closest?.('#CartDrawer-Checkout');
      if (!button || !this.contains(button)) return;
      event.preventDefault(); event.stopImmediatePropagation();
      this.nvProceedCheckout();
    };
    this.addEventListener('submit', event => {
      if (event.submitter?.id !== 'CartDrawer-Checkout' && event.submitter?.name !== 'checkout') return;
      event.preventDefault(); event.stopImmediatePropagation();
      this.nvProceedCheckout();
    }, true);
    this.nvPackBusy = false;
    this.addEventListener('click', event => {
      const button = event.target.closest?.('[data-nv-next-offer]');
      if (!button) return;
      event.preventDefault(); event.stopImmediatePropagation();
      const item = button.closest('[data-nv-product]');
      if (item) this.changePackOffer(item, Number(button.dataset.nvNextOffer));
    }, true);
    this.addEventListener('click', event => {
      const remove = event.target.closest?.('cart-remove-button');
      const item = remove?.closest('[data-nv-product]');
      if (!item) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.nvRemovePack();
    }, true);
    this.addEventListener('click', event => this.handlePackClick(event), true);
    this.addEventListener('change', event => this.handlePackChange(event), true);

    this.applyStyles();
    this.refreshCartLayout();

    this.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') this.close();
    });

    this.bindOverlay();
    this.setHeaderCartIconAccessibility();
  }

  connectedCallback() {
    document.removeEventListener('click', this.nvCheckoutClickHandler, true);
    document.addEventListener('click', this.nvCheckoutClickHandler, true);
    this.observer?.disconnect();

    this.observer = new MutationObserver(records => {
      if (records.length && records.every(record => record.target.closest?.('[data-nv-clock]'))) return;
      if (records.length && records.every(record => record.type === 'attributes' && record.target === this)) {
        this.syncReservationState();
        return;
      }
      if (this.nvApplyingLayout) return;
      this.nvApplyingLayout = true;
      try {
        this.refreshCartLayout();
        this.bindOverlay();
        this.syncReservationState();
      } finally {
        this.observer.takeRecords();
        this.nvApplyingLayout = false;
      }
    });

    this.observer.observe(this, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    this.refreshCartLayout();
    this.syncReservationState();
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.nvCheckoutClickHandler, true);
    this.observer?.disconnect();
    clearInterval(this.timerInterval);
    clearTimeout(this.nvProtectionTimer);
    if (!this.classList.contains('active') && this.nvProductCache) {
      for (const key of this.nvProductCache.keys()) {
        if (/\/products\/(?:pack-bienestar-nurevia-2-guias|gift-card-de-regalo-10-000)\.js/.test(key)) this.nvProductCache.delete(key);
      }
    }
    clearTimeout(this.openTimeout);
    this.removeFocusTransitionHandler();

    this.timerInterval = null;
    this.timerEnd = null;
    this.reservationWasOpen = false;
  }

  refreshCartLayout() {
    this.nvSyncEmptyUI();
    this.updateCartTitle();
    this.updateContinueShopping();
    this.updateProductBlocks();
    this.updatePackControls();
    this.nvUpdateOfferTracker();
    this.updateTrustBlock();
    this.nvUpdateWellnessGift();
    this.updateCheckoutFooter();
    this.nvProtectionLayout();
    this.nvRefreshGiftProducts();
    this.nvScheduleProtection();
  }

  nvSyncEmptyUI() {
    const empty = !this.hasCartProducts();
    this.classList.toggle('is-empty', empty);
    const inner = this.querySelector('.drawer__inner');
    if (!inner) return;
    inner.classList.toggle('is-empty', empty);
    if (!empty) {
      this.querySelector('[data-nv-empty-fallback]')?.remove();
      return;
    }
    this.hideReservation();
    this.querySelectorAll('[data-nv-wellness-gift], [data-nv-trust], [data-nv-offer-tracker]').forEach(block => block.remove());
    this.removeAttribute('aria-busy');
    this.querySelectorAll('.cart__items--disabled').forEach(node => node.classList.remove('cart__items--disabled'));
    if (this.querySelector('[data-nv-empty-fallback]')) return;
    inner.querySelectorAll('.drawer__inner-empty').forEach(node => node.remove());
    const block = document.createElement('div');
    block.className = 'drawer__inner-empty';
    block.dataset.nvEmptyFallback = '';
    const warnings = document.createElement('div');
    warnings.className = 'cart-drawer__warnings center';
    const title = document.createElement('h2');
    title.className = 'cart__empty-text';
    title.textContent = 'Tu carrito está vacío';
    const link = document.createElement('a');
    link.className = 'button';
    link.href = window.Shopify?.routes?.root || '/';
    link.textContent = 'Seguir comprando';
    link.dataset.nvContinueShopping = '';
    warnings.append(title, link);
    const closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.setAttribute('aria-label', 'Cerrar carrito');
    closeButton.dataset.nvEmptyClose = '';
    closeButton.textContent = '×';
    closeButton.addEventListener('click', () => this.close());
    block.append(closeButton, warnings);
    this.append(block);
  }

  applyStyles() {
    let style = document.getElementById('cart-drawer-hide-promo');

    if (!style) {
      style = document.createElement('style');
      style.id = 'cart-drawer-hide-promo';
      document.head.appendChild(style);
    }

    style.textContent = `
      cart-drawer.is-empty .drawer__footer,
      cart-drawer.is-empty cart-drawer-items,
      cart-drawer.is-empty [data-nv-wellness-gift],
      cart-drawer.is-empty [data-nv-trust] { display:none !important; }
      cart-drawer.is-empty .loading__spinner,cart-drawer.is-empty .loading-overlay,cart-drawer.is-empty .cart-drawer__loading{display:none!important}
      cart-drawer.is-empty .drawer__inner{opacity:1!important;pointer-events:auto!important}
      cart-drawer.is-empty [data-nv-empty-fallback]{z-index:2!important;background:#fff!important;opacity:1!important;pointer-events:auto!important}
      cart-drawer.is-empty .drawer__inner { position:relative!important;height:100%!important;min-height:0!important; }
      cart-drawer.is-empty .drawer__inner-empty { display:flex!important;position:absolute!important;inset:0!important;flex-direction:column!important;align-items:center!important;justify-content:center!important;width:100%!important;height:100%!important;margin:0!important;padding:60px 20px!important;box-sizing:border-box!important; }
      cart-drawer.is-empty .cart-drawer__empty-content { margin:0!important;width:100%!important; }
      cart-drawer.is-empty .cart-drawer__warnings { margin:0!important;padding:0!important; }
      cart-drawer.is-empty .drawer__close { z-index:3!important; }
      cart-drawer.is-empty .cart__empty-text { margin:0 0 18px!important; }
      cart-drawer.is-empty .cart-drawer__warnings .button { margin-top:0!important; }
      cart-drawer.is-empty .cart-drawer__warnings { display:block !important;text-align:center; }
      cart-drawer:not(.is-empty) .drawer__inner-empty { display:none !important; }
      cart-drawer [data-nv-empty-fallback] .button { background:#0F554C!important;color:#fff!important;margin-top:18px; }
      cart-drawer:not(.active) {
        visibility: hidden !important;
        pointer-events: none !important;
        background: transparent !important;
      }

      cart-drawer.active {
        visibility: visible !important;
        pointer-events: auto !important;
      }

      cart-drawer:not(.active) #CartDrawer-Overlay {
        visibility: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
      }

      cart-drawer.active #CartDrawer-Overlay {
        visibility: visible !important;
        opacity: 1 !important;
        pointer-events: auto !important;
      }

      cart-drawer .ct-message,
      cart-drawer .cart-goal-container,
      cart-drawer #cart-progress-wrapper,
      cart-drawer .cart-upsell-toggle-container {
        display: none !important;
      }

      cart-drawer .drawer__heading {
        font-size: 26px !important;
        line-height: 1.2 !important;
      }

      cart-drawer [data-nv-reservation] {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        flex-shrink: 0;
        min-height: 36px;
        margin: 0 0 4px;
        padding: 9px 12px;
        background: #0F554C;
        color: #ffffff;
        font-size: 13px;
        font-weight: 400;
        line-height: 1.3;
        text-align: center;
        box-sizing: border-box;
      }

      cart-drawer [data-nv-clock] {
        color: #ffffff;
        font-weight: 700;
        font-variant-numeric: tabular-nums;
      }

      cart-drawer .drawer__inner-empty [data-nv-reservation],
      cart-drawer.is-empty [data-nv-reservation] {
        display: none !important;
      }

      cart-drawer [data-nv-continue-shopping] {
        background: #0F554C !important;
        color: #ffffff !important;
        border-color: #0F554C !important;
        --color-button: 15, 85, 76;
        --color-button-text: 255, 255, 255;
      }

      cart-drawer [data-nv-continue-shopping]::after {
        box-shadow: none !important;
      }

      cart-drawer .cart-items,
      cart-drawer .cart-items tbody {
        margin-top: 0 !important;
      }

      cart-drawer .cart-item[data-nv-product] {
        display: grid !important;
        grid-template-columns: 90px minmax(0, 1fr) !important;
        grid-template-rows: auto !important;
        column-gap: 12px !important;
        row-gap: 0 !important;
        width: 100% !important;
        padding-top: 8px !important;
        margin-top: 0 !important;
        align-items: start !important;
      }

      cart-drawer [data-nv-product] > .cart-item__media {
        grid-column: 1 !important;
        grid-row: 1 !important;
        width: 90px !important;
        min-width: 0 !important;
        padding: 0 !important;
      }

      cart-drawer [data-nv-product] .cart-item__image {
        width: 90px !important;
        max-width: 90px !important;
        height: auto !important;
        object-fit: contain;
      }

      cart-drawer [data-nv-product] > .cart-item__details {
        grid-column: 2 / -1 !important;
        grid-row: 1 !important;
        width: auto !important;
        min-width: 0 !important;
        max-width: none !important;
        padding: 0 !important;
      }

      cart-drawer [data-nv-product] > .cart-item__totals {
        display: none !important;
      }

      cart-drawer [data-nv-product] > .cart-item__quantity {
        grid-column: 2 / -1 !important;
        width: auto !important;
        min-width: 0 !important;
        padding: 0 !important;
        margin: 0 !important;
      }

      cart-drawer [data-nv-product] .cart-item__name {
        display: block;
        width: 100%;
        max-width: none !important;
        margin: 0 !important;
        font-size: 15px !important;
        font-weight: 700 !important;
        line-height: 1.35 !important;
        text-decoration: none !important;
        overflow-wrap: normal;
        word-break: normal;
      }

      cart-drawer [data-nv-product-subtitle] {
        margin: 6px 0 3px !important;
        color: #777777;
        font-size: 12px;
        font-weight: 400;
        line-height: 1.3;
      }

      cart-drawer [data-nv-hide-offer],
      cart-drawer [data-nv-hide-options] {
        display: none !important;
      }

      cart-drawer [data-nv-product-prices] {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 8px;
        width: 100%;
        margin: 0 !important;
      }

      cart-drawer [data-nv-unit-column] {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;
        min-width: 0;
      }

      cart-drawer [data-nv-unit-price] {
        display: none !important;
        align-items: baseline;
        gap: 4px;
        margin: 0;
        white-space: nowrap;
      }

      cart-drawer [data-nv-offer-price],
      cart-drawer [data-nv-original-unit],
      cart-drawer [data-nv-original-unit] .cart-item__final-price,
      cart-drawer [data-nv-original-unit] .product-option {
        color: #2C8249 !important;
        font-size: 14px !important;
        font-weight: 700 !important;
        line-height: 1.3 !important;
      }

      cart-drawer [data-nv-original-unit] {
        margin: 0 !important;
        padding: 0 !important;
      }

      cart-drawer [data-nv-original-unit][hidden],
      cart-drawer [data-nv-original-unit] s {
        display: none !important;
      }

      cart-drawer [data-nv-unit-label] {
        color: #000000;
        font-size: 12px;
        font-weight: 400;
        line-height: 1.3;
      }

      cart-drawer [data-nv-product-prices] .cart-item__price-wrapper {
        flex-shrink: 0;
        margin: 0 !important;
        padding: 0 !important;
        text-align: right;
        white-space: nowrap;
      }

      cart-drawer [data-nv-total-label] {
        display: block;
        margin-bottom: 2px;
        color: #777777;
        font-size: 11px;
        font-weight: 400;
        line-height: 1.2;
      }

      cart-drawer [data-nv-product-prices] .cart-item__price-wrapper .price,
      cart-drawer [data-nv-product-prices] .cart-item__price-wrapper .cart-item__final-price {
        margin: 0 !important;
        color: #000000 !important;
        font-size: 14px !important;
        font-weight: 700 !important;
        line-height: 1.3 !important;
      }

      cart-drawer [data-nv-unit-column] quantity-popover {
        display: block;
        margin: 0 !important;
        padding: 0 !important;
      }

      cart-drawer [data-nv-unit-column] .cart-item__quantity-wrapper,
      cart-drawer [data-nv-unit-column] .cart-drawer-quantity-wrapper {
        display: flex;
        align-items: center;
        gap: 8px;
        margin: 0 !important;
        padding: 0 !important;
      }

      cart-drawer [data-nv-unit-column] quantity-input {
        display: flex;
        align-items: center;
        width: 144px !important;
        min-width: 144px !important;
        min-height: 46px !important;
        height: 46px !important;
        border: 1px solid #dddddd !important;
        border-radius: 6px;
        background: #ffffff;
        box-sizing: border-box;
      }

      cart-drawer [data-nv-unit-column] quantity-input::before,
      cart-drawer [data-nv-unit-column] quantity-input::after {
        display: none !important;
      }

      cart-drawer [data-nv-unit-column] .quantity__button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 46px !important;
        min-width: 46px !important;
        height: 44px !important;
        padding: 0 !important;
        flex-shrink: 0;
      }

      cart-drawer [data-nv-unit-column] .quantity__button:disabled {
        opacity: .35;
        cursor: not-allowed;
      }

      cart-drawer [data-nv-unit-column] .quantity__button svg {
        width: 14px !important;
        height: 14px !important;
      }

      cart-drawer [data-nv-unit-column] .quantity__input {
        flex: 1;
        width: 50px !important;
        min-width: 0 !important;
        height: 44px !important;
        padding: 0 !important;
        font-size: 17px !important;
        font-weight: 700 !important;
        text-align: center;
      }

      cart-drawer [data-nv-unit-column] cart-remove-button {
        margin: 0 !important;
      }

      cart-drawer [data-nv-unit-column] cart-remove-button .button {
        min-width: 34px !important;
        min-height: 46px !important;
        padding: 0 !important;
      }

      cart-drawer [data-nv-unit-column] cart-remove-button svg {
        width: 24px !important;
        height: 24px !important;
      }

      cart-drawer .drawer__footer {
        background: #ffffff !important;
        padding-top: 0 !important;
        border-top: 0 !important;
        box-shadow: none !important;
      }

      cart-drawer .cart-drawer__footer {
        background: #ffffff !important;
      }

      cart-drawer .drawer__footer [data-nv-trust] {
        display: grid;
        grid-template-columns: 1fr 1fr 1.2fr;
        align-items: center;
        gap: 8px;
        width: 100%;
        margin: 0 !important;
        padding: 6px 0 !important;
        background: #ffffff;
        color: #000000;
        box-sizing: border-box;
      }

      cart-drawer [data-nv-trust-item] {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;
        min-width: 0;
      }

      cart-drawer [data-nv-trust-item] svg {
        width: 22px;
        height: 22px;
        flex-shrink: 0;
      }

      cart-drawer [data-nv-trust-item] span {
        color: #000000;
        font-size: 10px;
        font-weight: 700;
        line-height: 1.25;
      }

      cart-drawer .drawer__footer [data-nv-trust] + .cart-drawer__footer {
        margin-top: 0 !important;
        padding-top: 0 !important;
      }

      cart-drawer .drawer__footer .totals {
        display: flex !important;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        margin: 0 0 12px !important;
        padding: 12px 0 !important;
        border-top: 1px solid #E3E3E3;
        border-bottom: 1px solid #E3E3E3;
      }

      cart-drawer .drawer__footer .totals__total,
      cart-drawer .drawer__footer .totals__total-value {
        margin: 0 !important;
        color: #000000 !important;
        font-size: 14px !important;
        font-weight: 700 !important;
        line-height: 1.3 !important;
      }

      cart-drawer .drawer__footer .totals__total-value {
        text-align: right;
      }

      cart-drawer .drawer__footer .tax-note,
      cart-drawer .drawer__footer .cart__ctas > a[href$="/cart"] {
        display: none !important;
      }

      cart-drawer .drawer__footer .cart__ctas {
        margin: 0 !important;
        padding-bottom: 0 !important;
      }

      cart-drawer #CartDrawer-Checkout {
        width: 100%;
        min-height: 48px;
        margin-bottom: 0 !important;
        padding: 12px;
        border-radius: 6px;
        background: #0F554C !important;
        color: #ffffff !important;
        font-size: 15px !important;
        font-weight: 700 !important;
        line-height: 1.3;
        text-align: center;
        --color-button: 15, 85, 76;
        --color-button-text: 255, 255, 255;
      }

      cart-drawer #CartDrawer-Checkout::after {
        box-shadow: none !important;
      }

      cart-drawer .drawer__footer .footer__payment {
        margin-top: 5px !important;
        margin-bottom: 0 !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
      }

      cart-drawer .drawer__footer .list-payment-drawer,
      cart-drawer .drawer__footer .list-payment {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
      }

      cart-drawer .drawer__footer .list-payment__item {
        padding-top: 0 !important;
        padding-bottom: 0 !important;
      }

      /* Proporciones de la referencia, conservando los bloques Nurevia. */
      cart-drawer.cart-drawer .drawer__heading,
      cart-drawer .drawer__heading {font-size:22px!important;font-weight:500!important;line-height:1.2!important}
      cart-drawer .cart-item[data-nv-product]{grid-template-columns:46px minmax(0,1fr)!important;column-gap:14px!important;padding-top:12px!important}
      cart-drawer [data-nv-product] > .cart-item__media{width:46px!important}
      cart-drawer [data-nv-product] .cart-item__image{width:46px!important;max-width:46px!important;height:auto!important;border-radius:3px}
      cart-drawer [data-nv-product] .cart-item__name{font-size:14px!important;font-weight:500!important;line-height:1.35!important}
      cart-drawer [data-nv-product-subtitle]{font-size:11px!important;margin:5px 0 8px!important;line-height:1.35!important}
      cart-drawer [data-nv-unit-column] quantity-input{width:108px!important;min-width:108px!important;height:34px!important;min-height:34px!important}
      cart-drawer [data-nv-unit-column] .quantity__button{width:34px!important;min-width:34px!important;padding:0!important;height:32px!important}
      cart-drawer [data-nv-unit-column] .quantity__button svg{width:12px!important;height:12px!important}
      cart-drawer [data-nv-unit-column] .quantity__input{width:38px!important;min-width:0!important;padding:0!important;font-size:14px!important;height:32px!important}
      cart-drawer [data-nv-unit-column] cart-remove-button .button{width:32px!important;min-width:32px!important;min-height:32px!important}
      cart-drawer [data-nv-unit-column] cart-remove-button svg{width:18px!important;height:18px!important}
      cart-drawer [data-nv-product-prices] .cart-item__price-wrapper .price,
      cart-drawer [data-nv-product-prices] .cart-item__price-wrapper .cart-item__final-price{font-size:14px!important;font-weight:500!important}
      cart-drawer [data-nv-offer-tracker]{margin-top:16px!important}
      cart-drawer .nv-offer-step strong{font-size:11px!important;font-weight:500!important}
      cart-drawer .nv-offer-summary{padding:10px!important}
      cart-drawer .nv-offer-current strong{font-size:12px!important;font-weight:500!important}
      cart-drawer .nv-offer-each strong{font-size:16px!important}
      cart-drawer .nv-offer-upgrade button{min-width:86px!important;padding:9px 12px!important;font-size:12px!important}
      cart-drawer .drawer__footer [data-nv-wellness-gift]{padding:10px!important;gap:10px!important;margin:10px 0 7px!important;min-height:82px!important}
      cart-drawer .drawer__footer .nv-gift-icon{width:46px!important;flex-basis:46px!important;height:58px!important}
      cart-drawer .drawer__footer .nv-gift-icon img{width:44px!important;height:56px!important}
      cart-drawer .drawer__footer .nv-gift-copy strong{font-size:14px!important;font-weight:500!important;line-height:1.2!important}
      cart-drawer .drawer__footer .nv-gift-copy p{font-size:10px!important;line-height:1.4!important}
      cart-drawer .drawer__footer .totals{padding:8px 0!important;margin-bottom:8px!important}
      cart-drawer .drawer__footer .totals__total,
      cart-drawer .drawer__footer .totals__total-value{font-size:15px!important;font-weight:500!important}
      cart-drawer #CartDrawer-Checkout{min-height:50px!important;font-size:15px!important;font-weight:500!important;padding:12px 8px!important}
      @media(max-width:360px){
        cart-drawer .drawer__footer .nv-gift-copy strong{font-size:12px!important}
        cart-drawer .drawer__footer .nv-gift-copy p{font-size:9px!important}
        cart-drawer .nv-offer-upgrade{gap:5px!important}
        cart-drawer .nv-offer-upgrade button{min-width:70px!important;padding:9px!important}
        cart-drawer #CartDrawer-Checkout{font-size:13px!important}
      }

      html:has(cart-drawer.active),body:has(cart-drawer.active){overflow:hidden!important;overscroll-behavior:none!important}
      cart-drawer.active{position:fixed!important;inset:0!important;height:100vh!important;height:100dvh!important;overflow:hidden!important;overscroll-behavior:none!important}
      cart-drawer.active .drawer__inner{height:100%!important;max-height:100%!important;overflow:hidden!important;display:flex!important;flex-direction:column!important;overscroll-behavior:none!important}
      cart-drawer.active .drawer__header,cart-drawer.active .drawer__footer,cart-drawer.active [data-nv-reservation]{flex-shrink:0!important}
      cart-drawer.active:not(.is-empty) cart-drawer-items{min-height:0!important;flex:1 1 auto!important;overflow-x:hidden!important;overflow-y:auto!important;overscroll-behavior:none!important}

      cart-drawer.active.is-empty > [data-nv-empty-fallback]{position:fixed!important;inset:0 0 0 auto!important;width:min(400px,100vw)!important;height:100vh!important;height:100dvh!important;max-height:none!important;display:flex!important;align-items:center!important;justify-content:center!important;flex-direction:column!important;background:#fff!important;color:#1f1d24!important;visibility:visible!important;opacity:1!important;transform:none!important;z-index:20!important;padding:60px 20px!important;pointer-events:auto!important}
      cart-drawer [data-nv-empty-close]{position:absolute;top:12px;right:14px;border:0;background:transparent;color:#222;font:32px/1 sans-serif;width:40px;height:40px;cursor:pointer}
      cart-drawer.is-empty > [data-nv-empty-fallback] .cart-drawer__warnings{display:block!important;visibility:visible!important;opacity:1!important;transform:none!important;width:100%;text-align:center}
      cart-drawer.is-empty > [data-nv-empty-fallback] .button{display:inline-flex!important;align-items:center;justify-content:center;min-height:44px;padding:10px 20px;background:#0F554C!important;color:white!important;text-decoration:none}

      cart-drawer:not(.active) > [data-nv-empty-fallback],
      cart-drawer:not(.is-empty) > [data-nv-empty-fallback]{display:none!important;visibility:hidden!important;pointer-events:none!important}
      cart-drawer:not(.active) > [data-nv-empty-fallback] *{visibility:hidden!important;pointer-events:none!important}

      @media(max-width:749px){
        cart-drawer.active .drawer__header{padding-top:8px!important;padding-bottom:8px!important;min-height:40px!important;margin-bottom:0!important}
        cart-drawer.active .drawer__heading{font-size:20px!important}
        cart-drawer.active [data-nv-reservation]{padding-top:7px!important;padding-bottom:7px!important;min-height:30px!important;font-size:12px!important;margin-bottom:0!important}
        cart-drawer.active .cart-item[data-nv-product]{padding-top:6px!important}
        cart-drawer.active [data-nv-product] .cart-item__name{font-size:15px!important;line-height:1.25!important}
        cart-drawer.active [data-nv-product-subtitle]{margin:4px 0 6px!important;font-size:12px!important}
        cart-drawer.active [data-nv-offer-tracker]{margin-top:12px!important}
        cart-drawer.active .nv-offer-steps{margin-bottom:10px!important}
        cart-drawer.active .nv-offer-step>span{width:28px!important;height:28px!important;margin-bottom:4px!important;font-size:11px!important}
        cart-drawer.active .nv-offer-line{top:13px!important}
        cart-drawer.active .nv-offer-step strong{font-size:13px!important}
        cart-drawer.active .nv-offer-step small{font-size:12px!important;margin-top:1px!important}
        cart-drawer.active .nv-offer-summary{padding:10px 11px!important;border-radius:8px!important}
        cart-drawer.active .nv-offer-current small{font-size:9px!important;margin-bottom:2px!important}
        cart-drawer.active .nv-offer-current strong{font-size:14px!important}
        cart-drawer.active .nv-offer-each strong{font-size:17px!important}
        cart-drawer.active .nv-offer-current span{margin-top:2px!important;font-size:11px!important}
        cart-drawer.active .nv-offer-upgrade{margin-top:9px!important;gap:5px!important}
        cart-drawer.active .nv-offer-upgrade strong{font-size:13px!important}
        cart-drawer.active .nv-offer-upgrade span{font-size:12px!important;line-height:1.25!important}
        cart-drawer.active .nv-offer-upgrade button{min-width:76px!important;padding:7px 10px!important;font-size:12px!important}
        cart-drawer.active .drawer__footer{padding-top:5px!important;padding-bottom:max(6px,env(safe-area-inset-bottom))!important}
        cart-drawer.active .drawer__footer [data-nv-wellness-gift]{min-height:0!important;padding:7px 8px!important;margin:5px 0!important;gap:8px!important}
        cart-drawer.active .drawer__footer .nv-gift-icon{height:42px!important;width:32px!important;flex-basis:32px!important}
        cart-drawer.active .drawer__footer .nv-gift-icon img{height:42px!important;width:32px!important}
        cart-drawer.active .drawer__footer .nv-gift-copy strong{font-size:14px!important;line-height:1.15!important}
        cart-drawer.active .drawer__footer .nv-gift-copy p{font-size:11px!important;line-height:1.25!important;margin-top:2px!important}
        cart-drawer.active .drawer__footer [data-nv-trust]{padding:4px 0!important}
        cart-drawer.active [data-nv-trust-item] span{font-size:10px!important}
        cart-drawer.active [data-nv-trust-item] svg{width:18px!important;height:18px!important}
        cart-drawer.active .drawer__footer .totals{padding:6px 0!important;margin-bottom:6px!important}
        cart-drawer.active .drawer__footer .totals__total,cart-drawer.active .drawer__footer .totals__total-value{font-size:14px!important}
        cart-drawer.active #CartDrawer-Checkout{min-height:46px!important;padding:10px 6px!important;font-size:15px!important}
        cart-drawer.active .drawer__footer .footer__payment{margin-top:3px!important;padding:0!important}
        cart-drawer.active .drawer__footer .list-payment{margin:0!important;padding:0!important}
        cart-drawer.active .drawer__footer .list-payment__item svg{max-height:20px!important;width:30px!important}
      }
    `;
  }

  updateTrustBlock() {
    if (!this.hasCartProducts()) {
      this.querySelectorAll('[data-nv-trust]').forEach((block) => {
        block.remove();
      });
      return;
    }

    if (this.querySelector('[data-nv-trust]')) return;

    const oldBlock = this.querySelector('.cart-upsell-toggle-container');
    const footer = this.querySelector('.drawer__footer');

    if (!oldBlock && !footer) return;

    const block = document.createElement('div');
    block.setAttribute('data-nv-trust', '');

    block.innerHTML = `
      <div data-nv-trust-item>
        <svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor">
          <path d="M2 5h12v11H2zM14 9h4l4 4v3h-8z"/>
          <path d="M16 10v3h4l-3-3z" fill="#ffffff"/>
          <circle cx="6" cy="17" r="3"/>
          <circle cx="18" cy="17" r="3"/>
          <circle cx="6" cy="17" r="1" fill="#ffffff"/>
          <circle cx="18" cy="17" r="1" fill="#ffffff"/>
        </svg>
        <span>Envío gratuito</span>
      </div>

      <div data-nv-trust-item>
        <svg
          viewBox="0 0 24 24"
          aria-hidden="true"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <rect x="2" y="5" width="17" height="13" rx="2"/>
          <path d="M2 9h17M5 14h3"/>
          <rect
            x="14" y="14" width="8" height="8" rx="1"
            fill="currentColor" stroke="none"
          />
          <path d="M16 14v-2a2 2 0 0 1 4 0v2"/>
          <path d="M18 17v2" stroke="#ffffff"/>
        </svg>
        <span>Pago seguro</span>
      </div>

      <div data-nv-trust-item>
        <svg
          viewBox="0 0 24 24"
          aria-hidden="true"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M3 6l8-4 8 4-8 4-8-4zM3 6v10l8 4V10M19 6v5M7 4l8 4"/>
          <path
            d="M18 12l4 2v4c0 2-4 4-4 4s-4-2-4-4v-4l4-2z"
            fill="currentColor"
          />
          <path
            d="M16 17l1.3 1.3L20 15.5"
            stroke="#ffffff"
            stroke-width="1.5"
          />
        </svg>
        <span>Garantía de 45 días</span>
      </div>
    `;

    if (oldBlock) {
      oldBlock.insertAdjacentElement('beforebegin', block);
    } else {
      footer.prepend(block);
    }
  }

  updateCheckoutFooter() {
    const footer = this.querySelector('.drawer__footer');
    if (!footer) return;

    const label = footer.querySelector('.totals__total');

    if (label && label.textContent !== 'Total') {
      label.textContent = 'Total';
    }

    const value = footer.querySelector('.totals__total-value');

    if (value) {
      const amount = this.readMoney(value);

      if (amount !== null) {
        const formatted = `$${new Intl.NumberFormat('es-CL', {
          maximumFractionDigits: 0
        }).format(amount)} CLP`;

        if (value.textContent !== formatted) {
          value.textContent = formatted;
        }
      }
    }

    const checkout = footer.querySelector('#CartDrawer-Checkout');

    if (
      checkout &&
      checkout.textContent !== 'CONTINUAR CON ENVÍO GRATIS'
    ) {
      checkout.textContent = 'CONTINUAR CON ENVÍO GRATIS';
    }
  }

  updateContinueShopping() {
    const homeUrl = window.Shopify?.routes?.root || '/';

    this.querySelectorAll(
      '.cart-drawer__empty-content > a.button, ' +
      '.cart-drawer__warnings a, ' +
      '.drawer__inner-empty a'
    ).forEach((link) => {
      const text = link.textContent.replace(/\s+/g, ' ').trim();

      if (
        !link.matches('.cart-drawer__empty-content > a.button') &&
        !/seguir comprando|continuar comprando|continue shopping/i.test(text)
      ) {
        return;
      }

      if (link.getAttribute('href') !== homeUrl) {
        link.setAttribute('href', homeUrl);
      }

      if (!link.hasAttribute('data-nv-continue-shopping')) {
        link.setAttribute('data-nv-continue-shopping', '');
      }
    });
  }

  nvUpdateWellnessGift() {
    this.querySelectorAll('[data-nv-wellness-gift]').forEach(block => block.remove());
  }

  nvUpdateUpgradeButton(button) {
    const loading = Boolean(this.nvPackBusy);
    button.disabled = Boolean(loading || this.nvProtectionBusy);
    button.setAttribute('aria-busy', String(loading));
    if (button.dataset.loading === String(loading)) return;
    button.dataset.loading = String(loading);
    button.innerHTML = loading
      ? '<span class="nv-upgrade-spinner" aria-hidden="true"></span>Agregar'
      : 'Agregar';
  }

  nvUpdateOfferTracker() {
    const money = value => '$' + value.toLocaleString('es-CL');
    const unit = {1: 24990, 2: 19995, 3: 16663};
    const totals = {1: 24990, 2: 39990, 3: 49990};
    this.querySelectorAll('[data-nv-product][data-nv-pack-level]').forEach(item => {
      const level = Number(item.dataset.nvPackLevel);
      if (!unit[level]) return;
      let tracker = item.querySelector('[data-nv-offer-tracker]');
      if (!tracker) {
        tracker = document.createElement('div');
        tracker.dataset.nvOfferTracker = '';
        item.appendChild(tracker);
      }
      tracker.classList.toggle('nv-offer-at-max', level === 3);
      const progress = this.nvOfferMotion;
      const initial = progress ? progress.visual : (level - 1) * 50;
      tracker.style.setProperty('--nv-offer-progress', initial + '%');
      if (progress && level === progress.to) {
        requestAnimationFrame(() => requestAnimationFrame(() => {
          if (tracker.isConnected) tracker.style.setProperty('--nv-offer-progress', ((level - 1) * 50) + '%');
        }));
      }
      const next = level + 1;
      const html = `<div class="nv-offer-steps"><span class="nv-offer-line" aria-hidden="true"><span></span></span><span class="nv-offer-sr" aria-label="Oferta actual: ${level} frascos"></span>${[1,2,3].map(step => `<div class="nv-offer-step ${step <= level ? 'nv-selected' : ''}"><span>${step <= level ? '✓' : step}</span><strong>Lleva ${step}</strong><small>${money(unit[step])} c/u</small></div>`).join('')}</div><div class="nv-offer-summary"><div class="nv-offer-current"><div><small>ESTÁS AQUÍ</small><strong>Pack ${level} ${level === 1 ? 'Mes' : 'Meses'} · ${level} ${level === 1 ? 'frasco' : 'frascos'}</strong></div><div class="nv-offer-each"><strong>${money(unit[level])}</strong><span>por frasco</span></div></div>${level < 3 ? `<div class="nv-offer-upgrade"><span class="nv-offer-arrow" aria-hidden="true"><svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m5 6 4 4-4 4m5-8 4 4-4 4"/></svg></span><div><strong>Ahorra más</strong><span>Pack ${next} Meses · ${next} frascos</span><span>${money(unit[next])} c/u (Ahorra ${money(unit[level] - unit[next])} por frasco)</span></div><button type="button" data-nv-next-offer="${next}">Agregar</button></div>` : '<div class="nv-offer-max">Ya tienes la oferta de mayor ahorro.</div>'}</div>`;
      if (tracker.dataset.level !== String(level)) {
        tracker.innerHTML = html;
        tracker.dataset.level = String(level);
      }
      const button = tracker.querySelector('button');
      if (button) this.nvUpdateUpgradeButton(button);
    });
    if (document.getElementById('nv-offer-tracker-style')) return;
    const style = document.createElement('style'); style.id = 'nv-offer-tracker-style';
    style.textContent = `cart-drawer [data-nv-offer-tracker]{grid-column:1/-1;width:100%;margin-top:10px;color:#111;text-align:left}cart-drawer .nv-offer-steps{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px;margin-bottom:14px;text-align:center;position:relative}cart-drawer .nv-offer-line{position:absolute;top:14px;left:16.66%;right:16.66%;height:2px;background:#ddd;overflow:hidden}cart-drawer .nv-offer-line>span{display:block;width:var(--nv-offer-progress,0%);height:100%;background:#3c9168;transition:width .45s ease}cart-drawer .nv-offer-sr{display:none}cart-drawer .nv-offer-step{position:relative}cart-drawer .nv-offer-step>span{background:white}cart-drawer .nv-offer-step>span{display:flex;align-items:center;justify-content:center;width:30px;height:30px;border:1px solid #ddd;border-radius:50%;margin:0 auto 7px;font-size:12px}cart-drawer .nv-offer-step.nv-selected>span{background:#3c9168;color:white;border-color:#3c9168;box-shadow:0 0 0 4px #dcece2}cart-drawer .nv-offer-step strong{display:block;font-size:11px;line-height:1.3}cart-drawer .nv-offer-step small{display:block;font-size:10px;line-height:1.4;margin-top:3px}cart-drawer .nv-offer-at-max .nv-offer-summary{display:none}cart-drawer .nv-offer-at-max .nv-offer-steps{margin-bottom:0}cart-drawer .nv-offer-summary{border:1px solid #e9e9e9;background:#fafafa;border-radius:12px;padding:11px 13px}cart-drawer .nv-offer-current{display:flex;justify-content:space-between;gap:8px}cart-drawer .nv-offer-current>div:first-child{flex:1;min-width:0}cart-drawer .nv-offer-current small{display:block;color:#6c877b;font-size:8px;letter-spacing:.8px;font-weight:700;line-height:1.2;text-transform:uppercase;margin-bottom:4px}cart-drawer .nv-offer-current strong{display:block;font-size:13px;line-height:1.3}cart-drawer .nv-offer-current span{display:block;font-size:10px;margin-top:4px}cart-drawer .nv-offer-each{text-align:right;white-space:nowrap;align-self:center}cart-drawer .nv-offer-each strong{font-size:18px;font-weight:500}cart-drawer .nv-offer-upgrade{display:flex;align-items:center;justify-content:space-between;gap:8px;margin-top:12px}cart-drawer .nv-offer-upgrade>div{flex:1;min-width:0}cart-drawer .nv-offer-arrow{display:flex!important;align-items:center;color:#159c68;flex:0 0 16px;width:16px}cart-drawer .nv-offer-arrow svg{display:block;width:16px;height:16px}cart-drawer .nv-offer-upgrade strong{display:block;font-size:11px}cart-drawer .nv-offer-upgrade span{display:block;font-size:10px;line-height:1.4}cart-drawer .nv-offer-upgrade button{display:inline-flex;align-items:center;justify-content:center;gap:6px;min-width:124px;border:0;border-radius:25px;background:#159c68;color:white;font-family:inherit;font-weight:700;font-size:11px;padding:9px 14px;cursor:pointer;flex-shrink:0}cart-drawer .nv-offer-upgrade button:disabled{opacity:.55;cursor:wait}cart-drawer .nv-offer-upgrade .nv-upgrade-spinner{display:inline-block;flex:0 0 12px;width:12px;height:12px;border:2px solid #ffffff66;border-top-color:#fff;border-radius:50%;animation:nv-upgrade-spin .7s linear infinite}@keyframes nv-upgrade-spin{to{transform:rotate(360deg)}}cart-drawer .nv-offer-max{margin-top:12px;color:#0F554C;font-size:11px}`;
    document.head.appendChild(style);
  }

  nvIsWellnessLink(link) {
    try {
      return decodeURIComponent(new URL(link.href, location.origin).pathname).replace(/\/$/, '').match(/\/products\/pack-bienestar-nurevia-2-guias(?:-gratis-🎁)?$/) !== null;
    } catch (_) { return false; }
  }

  async nvPrepareBundleGifts() {
    if (this.nvGiftSkuTask) return this.nvGiftSkuTask;
    this.nvGiftSkuTask = Promise.all([
      ['pack-bienestar-nurevia-2-guias', 'PACKGUIAS2'],
      ['gift-card-de-regalo-10-000', 'GIFTCARD10000']
    ].map(async ([handle, sku], index) => {
      const product = await this.nvLoadPackProduct(this.nvRoute('products/' + handle + '.js'));
      const variant = product.variants.find(item => String(item.sku || '').trim().toUpperCase() === sku);
      if (!variant || !variant.available || Number(variant.price) !== (index === 1 ? 1000000 : 1299000)) {
        throw new Error('Revisa el regalo ' + sku + (index === 1 ? ': debe estar disponible con valor $10.000 y descuento automático del 100% para la oferta 3.' : ': debe estar disponible con precio $12.990 y descuento automático del 100% en las ofertas 2 y 3.'));
      }
      return Number(variant.id);
    })).then(([guides, card]) => {
      this.nvWellnessId = guides;
      this.nvGiftCardId = card;
    }).catch(error => { this.nvGiftSkuTask = null; throw error; });
    return this.nvGiftSkuTask;
  }

  nvBundleLevel(cart) {
    return Math.max(0,...cart.items.map(line => Number(String(line.sku || '').match(/^NUREVIA-PACK-([123])$/i)?.[1]) || 0));
  }

  nvGiftUpdates(cart, hasProducts) {
    const level = hasProducts ? this.nvBundleLevel(cart) : 0;
    this.nvWellnessEnabled = level >= 2;
    const updates = {};
    cart.items.filter(line => Number(line.variant_id) === this.nvOldWellnessId && Number(line.variant_id) !== this.nvWellnessId).forEach(line => { updates[line.key] = 0; });
    cart.items.filter(line => Number(line.variant_id) === 68230719865044 || String(line.sku || '').toUpperCase() === 'GIFTCARD10').forEach(line => { updates[line.key] = 0; });
    [this.nvWellnessId,this.nvGiftCardId].forEach((id,index) => {
      if (!id) return;
      const desired = level >= index + 2 ? 1 : 0;
      const lines = cart.items.filter(line => Number(line.variant_id) === id);
      lines.forEach((line,i) => { if (line.quantity !== (i === 0 ? desired : 0)) updates[line.key] = i === 0 ? desired : 0; });
      if (!lines.length && desired) updates[String(id)] = 1;
    });
    return updates;
  }

  async nvValidateGift() {
    const url = this.nvRoute(this.nvWellnessProductPath.replace(/^\//, ''));
    const product = await this.nvLoadPackProduct(url);
    const variant = product.variants.find(item => Number(item.id) === this.nvWellnessId);
    if (!variant || Number(variant.price) !== 1299000) throw new Error('Las guías deben tener precio $12.990 y un descuento automático del 100% en las ofertas 2 y 3.');
    if (!variant.available) throw new Error('Las guías gratuitas no están disponibles en este momento.');
  }

  nvIsProtectionLink(link) {
    try { return new URL(link.href, location.origin).pathname.replace(/\/$/, '').endsWith('/products/proteccion-de-envio'); }
    catch (_) { return false; }
  }

  nvRefreshGiftProducts() {
    this.nvDecorateGiftRows();
    const packNode = this.querySelector('.cart-item[data-nv-product]');
    if (!packNode) return Promise.resolve();
    const signature = this.nvProtectionDOMSignature();
    if (this.nvRealGiftTask) {
      if (this.nvGiftRenderPack !== packNode || this.nvGiftRenderSignature !== signature) this.nvRealGiftQueued = true;
      return this.nvRealGiftTask;
    }
    if (this.nvGiftRenderPack === packNode && this.nvGiftRenderSignature === signature && this.nvGiftRenderDone) return Promise.resolve();
    this.nvGiftRenderPack = packNode;
    this.nvGiftRenderSignature = signature;
    this.nvGiftRenderDone = false;
    this.nvRealGiftTask = Promise.resolve().then(async () => {
      const [cart] = await Promise.all([this.nvReadCart(), this.nvPrepareBundleGifts()]);
      const pack = this.querySelector('.cart-item[data-nv-product]');
      if (!pack) return;
      const gifts = [
        {id:this.nvWellnessId,handle:'pack-bienestar-nurevia-2-guias',compare:1299000},
        {id:this.nvGiftCardId,handle:'gift-card-de-regalo-10-000',compare:1000000}
      ];
      const money = cents => '$' + new Intl.NumberFormat('es-CL',{maximumFractionDigits:0}).format(cents / 100);
      gifts.forEach(gift => {
        const line = cart.items.find(item => Number(item.variant_id) === gift.id);
        const existing = [...this.querySelectorAll('.cart-item')].find(row => {
          const link = row.querySelector('.cart-item__name');
          return link && String(link.getAttribute('href')).split('?')[0].endsWith('/products/' + gift.handle);
        });
        if (!line) {
          if (existing?.hasAttribute('data-nv-generated-gift')) existing.remove();
          return;
        }
        if (existing) {
          this.nvSetGiftPrices(existing, line, gift.compare);
          return;
        }
        const row = document.createElement(pack.tagName === 'TR' ? 'tr' : 'div');
        row.className = 'cart-item';
        row.setAttribute('data-nv-generated-gift','');
        row.setAttribute('data-nv-gift-native','');
        row.dataset.nvGiftMetadata = 'ready';
        row.innerHTML = '<td class="cart-item__media"><img class="cart-item__image" width="44" height="50" loading="eager" decoding="async"></td><td class="cart-item__details"><a class="cart-item__name"></a><p data-nv-gift-description></p></td><td class="cart-item__totals"><div class="cart-item__price-wrapper"><div data-nv-gift-prices><span></span><s></s></div></div></td>';
        row.querySelector('[data-nv-gift-description]').textContent = gift.handle === 'pack-bienestar-nurevia-2-guias' ? 'Movilidad + alimentación práctica para complementar tu rutina diaria.' : 'Úsala en tu próxima compra y disfruta $10.000 de descuento.';
        const link = row.querySelector('.cart-item__name');
        link.href = line.url || this.nvRoute('products/' + gift.handle);
        link.textContent = gift.handle === 'gift-card-de-regalo-10-000' ? 'Gift Card de Regalo $10.000' : (line.product_title || line.title);
        const image = row.querySelector('img');
        image.src = line.featured_image?.url || line.image || (gift.id === 67795740295380 ? 'https://cdn.shopify.com/s/files/1/0856/4110/1524/files/Guias_Nurevia__Movilidad_y_Dieta_Mediterranean.webp?v=1792234064' : 'https://cdn.shopify.com/s/files/1/0856/4110/1524/files/Tarjeta_regalo_dorada_Nurevia.webp?v=1793325539');
        image.alt = link.textContent;
        row.querySelector('[data-nv-gift-prices] span').textContent = money(Number(line.final_line_price ?? line.line_price ?? 0));
        row.querySelector('s').textContent = money(gift.compare);
        pack.parentElement.appendChild(row);

      });
      this.nvDecorateGiftRows();
      this.nvGiftRenderDone = true;
    }).catch(error => this.showPackError('No se pudieron mostrar los regalos: ' + error.message)).finally(() => { this.nvRealGiftTask = null; if (this.nvRealGiftQueued) { this.nvRealGiftQueued = false; this.nvRefreshGiftProducts(); } });
    return this.nvRealGiftTask;
  }

  nvSetGiftPrices(row, line, comparison) {
    const wrapper = row.querySelector('.cart-item__totals .cart-item__price-wrapper') || row.querySelector('.cart-item__totals');
    if (!wrapper) return;
    let box = wrapper.querySelector('[data-nv-gift-prices]');
    if (!box) {
      box = document.createElement('div');
      box.dataset.nvGiftPrices = '';
      box.appendChild(document.createElement('span'));
      box.appendChild(document.createElement('s'));
      wrapper.appendChild(box);
    }
    const money = value => '$' + new Intl.NumberFormat('es-CL',{maximumFractionDigits:0}).format(value / 100);
    const finalPrice = Number(line.final_line_price ?? line.line_price);
    const value = box.querySelector('span');
    const old = box.querySelector('s');
    const currentText = Number.isFinite(finalPrice) ? money(finalPrice) : '';
    if (value.textContent !== currentText) value.textContent = currentText;
    const compareText = money(comparison);
    if (old.textContent !== compareText) old.textContent = compareText;
    old.hidden = !comparison;
  }

  nvDecorateGiftRows() {
    this.querySelectorAll('[data-nv-gift-products]').forEach(block => block.remove());
    const packs = [...this.querySelectorAll('.cart-item[data-nv-product]')];
    let anchor = packs[packs.length - 1];
    if (!anchor) return;
    const handles = ['pack-bienestar-nurevia-2-guias','gift-card-de-regalo-10-000'];
    const rows = [...this.querySelectorAll('.cart-item')];
    handles.forEach(handle => {
      rows.forEach(row => {
        const link = row.querySelector('.cart-item__name');
        if (!link) return;
        let matches = false;
        try { matches = new URL(link.href,location.origin).pathname.replace(/\/$/, '').endsWith('/products/' + handle); } catch (_) {}
        if (!matches) return;
        if (handle === 'gift-card-de-regalo-10-000' && link.textContent !== 'Gift Card de Regalo $10.000') link.textContent = 'Gift Card de Regalo $10.000';
        row.hidden = false;
        row.setAttribute('data-nv-gift-native','');
        // Reutiliza la fila real creada por Shopify y conserva el regalo en el pedido.
        if (anchor.nextElementSibling !== row) anchor.insertAdjacentElement('afterend',row);
        anchor = row;
        const details = row.querySelector('.cart-item__details');
        if (details) {
          let copy = details.querySelector('[data-nv-gift-description]');
          if (!copy) {
            copy = document.createElement('p');
            copy.dataset.nvGiftDescription = '';
            link.insertAdjacentElement('afterend',copy);
          }
          const description = handle === 'pack-bienestar-nurevia-2-guias'
            ? 'Movilidad + alimentación práctica para complementar tu rutina diaria.'
            : 'Úsala en tu próxima compra y disfruta $10.000 de descuento.';
          if (copy.textContent !== description) copy.textContent = description;
        }
        const cart = this.nvRenderingCart || this.nvCartCache?.cart;
        const sku = handle === 'gift-card-de-regalo-10-000' ? 'GIFTCARD10000' : 'PACKGUIAS2';
        const line = cart?.items?.find(item => String(item.sku || '').toUpperCase() === sku);
        if (line) this.nvSetGiftPrices(row, line, sku === 'GIFTCARD10000' ? 1000000 : 1299000);
        row.dataset.nvGiftMetadata = 'ready';
      });
    });
    if (!document.getElementById('nv-native-gifts-style')) {
      const style = document.createElement('style');
      style.id = 'nv-native-gifts-style';
      style.textContent = `
        cart-drawer .cart-items .cart-item[data-nv-gift-native]{display:grid!important;visibility:visible!important;opacity:1!important;grid-template-columns:44px minmax(0,1fr) auto!important;align-items:center!important;gap:10px!important;padding:10px 0!important;margin:0!important;border-top:1px solid #e7e7e7!important;width:100%!important;height:auto!important;min-height:0!important}
        cart-drawer [data-nv-gift-native]>.cart-item__media{grid-column:1!important;grid-row:1!important;width:44px!important;padding:0!important}
        cart-drawer [data-nv-gift-native] .cart-item__image{width:44px!important;height:50px!important;object-fit:contain!important;display:block!important}
        cart-drawer [data-nv-gift-native]>.cart-item__details{grid-column:2!important;grid-row:1!important;padding:0!important;min-width:0!important}
        cart-drawer [data-nv-gift-native] .cart-item__name{font-family:inherit!important;font-size:12px!important;line-height:1.25!important;font-weight:500!important;color:#111!important;text-decoration:none!important;display:block!important;margin:0!important}
        cart-drawer [data-nv-gift-native] [data-nv-gift-description]{font-family:inherit!important;font-size:10px!important;font-weight:400!important;line-height:1.3!important;color:#777!important;margin:3px 0 0!important}
        cart-drawer [data-nv-gift-native]>.cart-item__totals{grid-column:3!important;grid-row:1!important;display:block!important;padding:0!important;text-align:right!important;font-size:12px!important;white-space:nowrap!important}
        cart-drawer [data-nv-gift-native] .cart-item__quantity,cart-drawer [data-nv-gift-native] .cart-item__details>div,cart-drawer [data-nv-gift-native] .cart-item__details>dl,cart-drawer [data-nv-gift-native] .cart-item__details>.discounts,cart-drawer [data-nv-gift-native] .loading__spinner{display:none!important}
        cart-drawer [data-nv-gift-prices]{display:flex!important;flex-direction:column;gap:3px;align-items:flex-end;font-size:12px!important;line-height:1.2!important}
        cart-drawer [data-nv-gift-prices] s{font-size:10px!important;color:#777!important;text-decoration:line-through!important}
        cart-drawer [data-nv-gift-native] .cart-item__price-wrapper>:not([data-nv-gift-prices]){display:none!important}
      `;
      document.head.appendChild(style);
    }
  }

  nvProtectionLayout() {
    this.querySelectorAll('[data-nv-protection]').forEach(block => block.remove());
    this.querySelectorAll('.cart-item').forEach(row => {
      const link = row.querySelector('.cart-item__name');
      if (link && this.nvIsProtectionLink(link)) row.hidden = true;
      if (link && (this.nvIsWellnessLink(link) || this.nvIsGiftCardLink(link))) row.hidden = false;
    });
    if (!document.getElementById('nv-protection-cleanup-style')) {
      const style = document.createElement('style');
      style.id = 'nv-protection-cleanup-style';
      style.textContent = 'cart-drawer .cart-item[hidden]{display:none!important}';
      document.head.appendChild(style);
    }
  }

  nvRememberCart(cart) {
    if (!Array.isArray(cart?.items) || !Number.isFinite(cart.item_count)) return;
    this.nvCartCache = {cart, at: Date.now(), signature: this.nvProtectionDOMSignature()};
  }

  async nvReadCart() {
    const signature = this.nvProtectionDOMSignature();
    const cached = this.nvCartCache;
    if (this.nvRenderingCart) return this.nvRenderingCart;
    if (cached && cached.signature === signature && Date.now() - cached.at < 3000) return cached.cart;
    if (this.nvCartReadTask?.signature === signature) return this.nvCartReadTask.promise;
    const task = {signature, promise: null};
    task.promise = this.nvGetJSON(this.nvRoute('cart.js')).then(cart => {
      if (signature === this.nvProtectionDOMSignature()) this.nvRememberCart(cart);
      return cart;
    }).finally(() => {
      if (this.nvCartReadTask === task) this.nvCartReadTask = null;
    });
    this.nvCartReadTask = task;
    return task.promise;
  }

  nvProtectionDOMSignature() {
    return JSON.stringify([...this.querySelectorAll('.cart-item:not([data-nv-generated-gift])')].map(row => [row.id, row.querySelector('.cart-item__name')?.getAttribute('href'), row.querySelector('.quantity__input')?.value]));
  }

  nvScheduleProtection() {
    if (!this.isConnected || this.nvProtectionBusy || this.nvPackBusy) return;
    const signature = this.nvProtectionDOMSignature();
    if (signature === this.nvProtectionSignature) return;
    clearTimeout(this.nvProtectionTimer);
    const checkout = this.querySelector('#CartDrawer-Checkout');
    if (checkout) checkout.disabled = true;
    this.nvProtectionTimer = setTimeout(() => this.nvSyncProtection(), 0);
  }

  nvSyncProtection() {
    if (this.nvSyncTask) return this.nvSyncTask;
    if (this.nvPackBusy) { this.nvGiftQueued = true; return Promise.resolve(); }
    clearTimeout(this.nvProtectionTimer);
    this.nvSyncTask = (async () => {
      let revision;
      do {
        revision = this.nvGiftRevision || 0;
        await this.nvPerformGiftSync(revision);
      } while (this.isConnected && revision !== (this.nvGiftRevision || 0));
    })().finally(() => { this.nvSyncTask = null; });
    return this.nvSyncTask;
  }

  async nvProceedCheckout() {
    if (this.nvCheckoutBusy || this.nvPackBusy) return;
    this.nvCheckoutBusy = true;
    try {
      await this.nvPrepareBundleGifts();
      await this.nvSyncProtection();
      const cart = await this.nvGetJSON(this.nvRoute('cart.js'));
      const level = this.nvBundleLevel(cart);
      if (!level) throw new Error('Tu carrito está vacío.');
      const updates = this.nvGiftUpdates(cart,true);
      if (Object.keys(updates).length) throw new Error('No se pudieron confirmar los regalos. Vuelve a intentarlo.');
      for (const id of [this.nvWellnessId,this.nvGiftCardId]) {
        if (cart.items.some(line => Number(line.variant_id) === id && Number(line.final_line_price) !== 0)) throw new Error(id === this.nvWellnessId ? 'Las guías no quedaron gratis. Revisa el descuento automático del 100% para las ofertas 2 y 3.' : 'La tarjeta no quedó gratis. Revisa el descuento automático del 100% para la oferta 3.');
      }
      window.location.assign(this.nvRoute('checkout'));
    } catch (error) { this.showPackError(error.message || 'No se pudo confirmar el carrito.'); }
    finally { this.nvCheckoutBusy = false; }
  }

  async nvPerformGiftSync(revision) {
    if (this.nvProtectionBusy || this.nvPackBusy || !this.isConnected) return;
    this.nvProtectionBusy = true;
    this.updatePackControls(); this.nvProtectionLayout(); this.nvUpdateWellnessGift();
    const checkout = this.querySelector('#CartDrawer-Checkout');
    if (checkout) checkout.disabled = true;
    try {
      const [cart] = await Promise.all([this.nvReadCart(),this.nvPrepareBundleGifts()]);
      const protection = cart.items.filter(line => Number(line.variant_id) === this.nvProtectionId);
      const hasProducts = cart.items.some(line => Number(line.variant_id) !== this.nvProtectionId && Number(line.variant_id) !== this.nvWellnessId && Number(line.variant_id) !== this.nvOldWellnessId);
      const giftUpdates = this.nvGiftUpdates(cart, hasProducts);
      if (hasProducts && this.nvWellnessEnabled && Object.keys(giftUpdates).length) await this.nvValidateGift();
      const desired = hasProducts && this.nvProtectionEnabled ? 1 : 0;
      const correct = desired ? protection.length === 1 && protection[0].quantity === 1 : protection.length === 0;
      if (!correct || Object.keys(giftUpdates).length) {
        const updates = {...giftUpdates};
        protection.forEach((line, index) => updates[line.key] = index === 0 ? desired : 0);
        if (!protection.length && desired) updates[String(this.nvProtectionId)] = 1;
        const sections = this.getSectionsToRender().map(section => section.id);
        const result = await this.nvGetJSON(this.nvRoute('cart/update.js'), {
          method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({updates:this.nvOrderCheckoutUpdates(updates,cart),sections,sections_url:location.pathname})
        });
        this.nvProtectionRendering = true;
        try { await this.nvRenderPackCart(result); }
        finally { this.nvProtectionRendering = false; }
        this.classList.toggle('is-empty', !hasProducts);
      }
      this.nvProtectionSignature = this.nvProtectionDOMSignature();
      this.showPackError('');
    } catch (error) {
      this.nvProtectionSignature = this.nvProtectionDOMSignature();
      try {
        const actual = await this.nvGetJSON(this.nvRoute('cart.js'));
        if (revision === (this.nvGiftRevision || 0)) this.nvWellnessEnabled = actual.items.some(line => Number(line.variant_id) === this.nvWellnessId);
        this.nvProtectionRendering = true;
        try { await this.nvRenderPackCart(actual); } finally { this.nvProtectionRendering = false; }
      } catch (_) { if (revision === (this.nvGiftRevision || 0)) this.nvWellnessEnabled = false; }
      try { sessionStorage.setItem('nv-wellness-gift', this.nvWellnessEnabled ? 'on' : 'off'); } catch (_) {}
      this.nvProtectionSignature = this.nvProtectionDOMSignature();
      this.showPackError(error.message || 'No se pudo actualizar el regalo. Inténtalo de nuevo.');
    } finally {
      this.nvProtectionBusy = false;
      this.updatePackControls(); this.nvProtectionLayout(); this.nvUpdateWellnessGift();
      const current = this.querySelector('#CartDrawer-Checkout');
      if (current) current.disabled = Boolean(this.nvPackBusy);
    }
  }

  nvIsGiftCardLink(link) {
    try { return new URL(link.href,location.origin).pathname.replace(/\/$/, '').match(/\/products\/gift-card-de-regalo-10-000(?:-gratis)?$/) !== null; } catch (_) { return false; }
  }

  hasCartProducts() {
    return [...this.querySelectorAll('cart-drawer-items .cart-item .cart-item__name')].some(link => !this.nvIsProtectionLink(link) && !this.nvIsWellnessLink(link) && !this.nvIsGiftCardLink(link));
  }

  updateCartTitle() {
    this.querySelectorAll('.drawer__heading').forEach((heading) => {
      if (heading.textContent !== 'TU CARRITO') {
        heading.textContent = 'TU CARRITO';
      }
    });
  }

  hideOfferOptions(details) {
    details.querySelectorAll('dl').forEach((list) => {
      list.querySelectorAll('dt').forEach((label) => {
        const text = label.textContent
          .trim()
          .replace(/[:\s]+$/g, '')
          .toLowerCase();

        if (text !== 'oferta' && text !== 'ofertas') return;

        const row = label.closest('.product-option');

        if (row && list.contains(row)) {
          if (!row.hasAttribute('data-nv-hide-offer')) {
            row.setAttribute('data-nv-hide-offer', '');
          }
        } else {
          if (!label.hasAttribute('data-nv-hide-offer')) {
            label.setAttribute('data-nv-hide-offer', '');
          }

          const value = label.nextElementSibling;

          if (
            value?.tagName === 'DD' &&
            !value.hasAttribute('data-nv-hide-offer')
          ) {
            value.setAttribute('data-nv-hide-offer', '');
          }
        }
      });

      const children = Array.from(list.children);

      const allHidden =
        children.length > 0 &&
        children.every((child) => {
          return child.hasAttribute('data-nv-hide-offer');
        });

      if (allHidden && !list.hasAttribute('data-nv-hide-options')) {
        list.setAttribute('data-nv-hide-options', '');
      } else if (
        !allHidden &&
        list.hasAttribute('data-nv-hide-options')
      ) {
        list.removeAttribute('data-nv-hide-options');
      }
    });
  }

  readMoney(element) {
    if (!element) return null;

    const copy = element.cloneNode(true);

    copy.querySelectorAll(
      's, .visually-hidden, [data-nv-total-label], .unit-price'
    ).forEach((node) => {
      node.remove();
    });

    const match = copy.textContent.match(/\d[\d.,\s]*/);
    if (!match) return null;

    let value = match[0].replace(/\s/g, '');

    if (/[.,]\d{2}$/.test(value)) {
      value = value.slice(0, -3);
    }

    value = Number(value.replace(/[.,]/g, ''));

    return Number.isFinite(value) ? value : null;
  }

  detectOffer(item, originalPrice) {
    const title = Array.from(item.querySelectorAll('.cart-item__details dl')).map(el => el.textContent).join(' ');
    const level = this.nvOfferFromTitle(title);
    if (level) return level;
    const price = this.readMoney(originalPrice?.querySelector('.cart-item__final-price') || originalPrice);
    return ({24990:1,39990:2,49990:3})[price] || null;
  }

  nvRoute(path) {
    const root = window.Shopify?.routes?.root || '/';
    return root.replace(/\/?$/, '/') + path;
  }

  nvOfferFromTitle(title) {
    const match = String(title || '').toLowerCase().match(/\b([123])\s*(?:frascos?|unidades?|mes(?:es)?)\b/);
    return match ? Number(match[1]) : null;
  }

  nvPackProductURL(item) {
    const link = item.querySelector('.cart-item__name');
    if (!link?.href) return null;
    const url = new URL(link.href, window.location.origin);
    if (url.origin !== window.location.origin) return null;
    url.search = '';
    url.hash = '';
    url.pathname = url.pathname.replace(/\/$/, '').replace(/\.js$/, '') + '.js';
    return url;
  }

  nvLoadPackProduct(url) {
    if (!this.nvProductCache) this.nvProductCache = new Map();
    const key = String(url);
    const cached = this.nvProductCache.get(key);
    if (cached && Date.now() - cached.created < 60000) return cached.promise;
    const entry = {created: Date.now(), promise: null};
    entry.promise = this.nvGetJSON(url).catch(error => {
      if (this.nvProductCache.get(key) === entry) this.nvProductCache.delete(key);
      throw error;
    });
    this.nvProductCache.set(key, entry);
    return entry.promise;
  }

  updatePackControls() {
    this.querySelectorAll('[data-nv-product]').forEach(item => {
      const input = item.querySelector('.quantity__input');
      if (!input) return;
      const original = item.querySelector('[data-nv-original-unit]');
      const bottles = this.detectOffer(item, original);
      if (![1, 2, 3].includes(bottles)) return;
      const level = bottles;
      item.dataset.nvPackLevel = String(level);
      input.setAttribute('min', '1');
      input.setAttribute('max', '3');
      input.setAttribute('step', '1');
      input.setAttribute('aria-label', 'Oferta: 1 pack de 2, 2 packs de 4 o 3 packs de 6 unidades');
      input.value = String(level);
      input.disabled = Boolean(this.nvPackBusy || this.nvProtectionBusy);
      const minus = item.querySelector('.quantity__button[name="minus"]');
      const plus = item.querySelector('.quantity__button[name="plus"]');
      if (minus) minus.disabled = Boolean(this.nvPackBusy || this.nvProtectionBusy) || level <= 1;
      if (plus) plus.disabled = Boolean(this.nvPackBusy || this.nvProtectionBusy) || level >= 3;
      const upgrade = item.querySelector('[data-nv-next-offer]');
      if (upgrade) this.nvUpdateUpgradeButton(upgrade);
      if (this.classList.contains('active')) {
        const url = this.nvPackProductURL(item);
        if (url) this.nvLoadPackProduct(url).catch(() => {});
      }
    });
  }

  async nvRemovePack() {
    if (this.nvPackBusy || this.nvCheckoutBusy) return;
    if (this.nvSyncTask) await this.nvSyncTask;
    if (this.nvPackBusy || this.nvCheckoutBusy) return;
    this.nvPackBusy = true;
    clearTimeout(this.nvProtectionTimer);
    this.setAttribute('aria-busy', 'true');
    this.updatePackControls();
    const checkout = this.querySelector('#CartDrawer-Checkout');
    if (checkout) checkout.disabled = true;
    let sent = false;
    try {
      const cart = await this.nvReadCart();
      const updates = {};
      cart.items.forEach(line => {
        const sku = String(line.sku || '').trim().toUpperCase();
        if (/^NUREVIA-PACK-[123]$/.test(sku) || ['PACKGUIAS2','GIFTCARD10000','GIFTCARD10'].includes(sku) ||
            [this.nvWellnessId,this.nvOldWellnessId,this.nvGiftCardId,this.nvProtectionId,68230719865044].includes(Number(line.variant_id))) {
          updates[line.key] = 0;
        }
      });
      if (!Object.keys(updates).length) throw new Error('El carrito cambió. Cierra y vuelve a abrirlo.');
      sent = true;
      const result = await this.nvGetJSON(this.nvRoute('cart/update.js'), {
        method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({updates,sections:this.getSectionsToRender().map(section => section.id),sections_url:location.pathname})
      });
      this.nvProtectionRendering = true;
      try { await this.nvRenderPackCart(result); }
      finally { this.nvProtectionRendering = false; }
      this.nvProtectionSignature = this.nvProtectionDOMSignature();
      this.showPackError('');
    } catch (error) {
      if (sent) {
        try { await this.nvRenderPackCart(await this.nvGetJSON(this.nvRoute('cart.js'))); } catch (_) {}
      }
      this.showPackError(error.message || 'No se pudo eliminar el pack. Inténtalo nuevamente.');
    } finally {
      this.nvPackBusy = false;
      this.removeAttribute('aria-busy');
      this.updatePackControls();
      const button = this.querySelector('#CartDrawer-Checkout');
      if (button) button.disabled = Boolean(this.nvProtectionBusy || this.nvCheckoutBusy);
      this.nvScheduleProtection();
    }
  }

  handlePackClick(event) {
    const button = event.target.closest?.('.quantity__button');
    const item = button?.closest('[data-nv-pack-level]');
    if (!button || !item || !['plus', 'minus'].includes(button.name)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (this.nvPackBusy) return;
    const level = Number(item.dataset.nvPackLevel);
    const next = level + (button.name === 'plus' ? 1 : -1);
    if (next < 1 || next > 3) return;
    this.changePackOffer(item, next, button.name);
  }

  handlePackChange(event) {
    const input = event.target;
    const item = input.closest?.('[data-nv-pack-level]');
    if (!item || !input.matches('.quantity__input')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const level = Number(input.value);
    input.value = item.dataset.nvPackLevel;
    if (this.nvPackBusy) return;
    if (!Number.isInteger(level) || level < 1 || level > 3) {
      this.showPackError('Puedes elegir entre 1 y 3 packs.');
      return;
    }
    if (level !== Number(item.dataset.nvPackLevel)) this.changePackOffer(item, level);
  }

  showPackError(message) {
    let error = this.querySelector('[data-nv-pack-error]');
    if (!message) {
      error?.remove();
      return;
    }
    if (!error) {
      error = document.createElement('p');
      error.setAttribute('data-nv-pack-error', '');
      error.setAttribute('role', 'alert');
      error.style.cssText = 'color:#b42318;font-size:13px;line-height:1.4;margin:8px 0;';
      const container = this.querySelector('.drawer__footer') || this.querySelector('.drawer__inner');
      container?.prepend(error);
    }
    error.textContent = message;
  }

  async nvGetJSON(url, options = {}) {
    const response = await fetch(url, {
      credentials: 'same-origin',
      cache: 'no-store',
      ...options,
      headers: {Accept: 'application/json', ...options.headers}
    });
    const result = await response.json();
    if (!response.ok || result.errors) {
      throw new Error(typeof result.description === 'string' ? result.description :
        typeof result.message === 'string' ? result.message :
        'No se pudo cambiar la oferta. Revisa su disponibilidad.');
    }
    return result;
  }

  nvOrderCheckoutUpdates(updates, cart) {
    // Solo cambia el orden de las entradas; conserva claves y cantidades.
    const priority = key => {
      const id = Number(cart.items.find(line => line.key === key)?.variant_id || key);
      return id === this.nvWellnessId ? 0 : id === this.nvGiftCardId ? 1 : 2;
    };
    return Object.fromEntries(Object.entries(updates).sort(([a], [b]) => priority(a) - priority(b)));
  }

  nvPackUpdates(cart, product, target) {
    const ids = new Set(product.variants.filter(v => this.nvOfferFromTitle(v.title))
      .map(v => String(v.id)));
    const lines = cart.items.filter(line => ids.has(String(line.variant_id)));
    if (!lines.length) throw new Error('El producto cambió. Cierra y vuelve a abrir el carrito.');
    if (lines.some(line => line.selling_plan_allocation)) {
      throw new Error('Esta compra tiene un plan de suscripción y no puede cambiarse desde este selector.');
    }
    const updates = {};
    let retained = false;
    lines.forEach(line => {
      if (!retained && String(line.variant_id) === String(target.id)) {
        updates[line.key] = 1;
        retained = true;
      } else {
        updates[line.key] = 0;
      }
    });
    if (!retained) updates[String(target.id)] = 1;
    return updates;
  }

  async nvRenderPackCart(state) {
    const sections = this.getSectionsToRender().map(section => section.id);
    if (!state.sections || sections.some(id => !state.sections[id])) {
      const url = new URL(this.nvRoute('cart'), window.location.origin);
      url.searchParams.set('sections', sections.join(','));
      state.sections = await this.nvGetJSON(url);
    }
    if (sections.some(id => !state.sections[id])) {
      throw new Error('No se pudo actualizar la vista del carrito. Recarga la página para ver el estado actual.');
    }
    this.nvRenderingCart = Array.isArray(state.items) && Number.isFinite(state.item_count) ? state : null;
    try { this.renderContents(state); }
    finally { this.nvRememberCart(state); this.nvRenderingCart = null; }
  }

  async changePackOffer(item, level, focusName) {
    if (this.nvPackBusy || this.nvCheckoutBusy || !Number.isInteger(level) || level < 1 || level > 3) return;
    if (this.nvSyncTask) {
      const currentId = item.id;
      await this.nvSyncTask;
      item = (currentId && this.querySelector('[id="' + currentId + '"]')) || this.querySelector('[data-nv-product]');
      if (!item || this.nvPackBusy || this.nvCheckoutBusy) return;
    }
    if (Number(item.dataset.nvPackLevel) === level) return;
    const productURL = this.nvPackProductURL(item);
    if (!productURL) return;
    this.nvPackBusy = true;
    this.nvUpdateWellnessGift();
    const fromLevel = Number(item.dataset.nvPackLevel);
    this.nvOfferMotion = {from: fromLevel, to: level, visual: (fromLevel - 1) * 50 + (level - fromLevel) * 40};
    const motionTracker = item.querySelector('[data-nv-offer-tracker]');
    motionTracker?.style.setProperty('--nv-offer-progress', this.nvOfferMotion.visual + '%');
    this.showPackError('');
    this.updatePackControls();
    const checkout = this.querySelector('#CartDrawer-Checkout');
    
    if (checkout) checkout.disabled = true;
    this.setAttribute('aria-busy', 'true');
    let sent = false;
    try {
      const [product, cart] = await Promise.all([
        this.nvLoadPackProduct(productURL),
        this.nvReadCart(),
        this.nvPrepareBundleGifts()
      ]);
      const target = product.variants.find(variant => this.nvOfferFromTitle(variant.title) === level);
      if (!target || !target.available) throw new Error('Esta oferta no está disponible en este momento.');
      const expected = {1: 2499000, 2: 3999000, 3: 4999000};
      if (Number(target.price) !== expected[level]) {
        throw new Error('El precio de esta oferta cambió. Revisa sus precios en Shopify antes de continuar.');
      }
      const updates = this.nvPackUpdates(cart, product, target);
      const packVariantIds = new Set(product.variants.map(v => String(v.id)));
      const giftCart = {items:cart.items.filter(line => !packVariantIds.has(String(line.variant_id))).concat([{...target,variant_id:target.id,sku:target.sku}])};
      const giftUpdates = this.nvGiftUpdates(giftCart, true);
      if (this.nvWellnessEnabled && Object.keys(giftUpdates).length) await this.nvValidateGift();
      Object.assign(updates, giftUpdates);
      const protection = cart.items.filter(line => Number(line.variant_id) === this.nvProtectionId);
      protection.forEach((line, index) => { updates[line.key] = this.nvProtectionEnabled && index === 0 ? 1 : 0; });
      if (this.nvProtectionEnabled && !protection.length) updates[String(this.nvProtectionId)] = 1;
      const sections = this.getSectionsToRender().map(section => section.id);
      sent = true;
      const result = await this.nvGetJSON(this.nvRoute('cart/update.js'), {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({updates:this.nvOrderCheckoutUpdates(updates,cart), sections, sections_url: window.location.pathname})
      });
      await this.nvRenderPackCart(result);
      this.nvProtectionSignature = this.nvProtectionDOMSignature();
      if (focusName) {
        requestAnimationFrame(() => {
          const controls = this.querySelector('[data-nv-pack-level]');
          const button = controls?.querySelector(`.quantity__button[name="${focusName}"]`);
          if (button && !button.disabled) button.focus();
          else controls?.querySelector('.quantity__input')?.focus();
        });
      }
    } catch (error) {
      // Si la respuesta se pierde, consulta el estado real sin repetir el cambio.
      if (sent) {
        try {
          const cart = await this.nvGetJSON(this.nvRoute('cart.js'));
          await this.nvRenderPackCart(cart);
        } catch (_) {}
      }
      this.showPackError(error.message || 'No se pudo cambiar la oferta. Inténtalo nuevamente.');
    } finally {
      const completedMotion = this.nvOfferMotion;
      this.nvOfferMotion = null;
      if (completedMotion) {
        this.querySelectorAll('[data-nv-offer-tracker]').forEach(tracker => {
          const actualLevel = Number(tracker.closest('[data-nv-pack-level]')?.dataset.nvPackLevel) || completedMotion.from;
          requestAnimationFrame(() => requestAnimationFrame(() => {
            if (tracker.isConnected) tracker.style.setProperty('--nv-offer-progress', ((actualLevel - 1) * 50) + '%');
          }));
        });
      }
      this.nvPackBusy = false;
      this.nvUpdateWellnessGift();
      this.removeAttribute('aria-busy');
      this.updatePackControls();
      const currentCheckout = this.querySelector('#CartDrawer-Checkout');
      if (currentCheckout) currentCheckout.disabled = Boolean(this.nvProtectionBusy || this.nvCheckoutBusy);
      if (this.nvGiftQueued) {
        this.nvGiftQueued = false;
        this.nvProtectionSignature = null;
        this.nvSyncProtection();
      } else this.nvScheduleProtection();
    }
  }

  positionQuantity(item, column) {
    if (!column) return;

    const quantity = item.querySelector('quantity-input');

    if (!quantity || column.contains(quantity)) return;

    const wrapper = quantity.closest(
      '.cart-item__quantity-wrapper, .cart-drawer-quantity-wrapper'
    );

    if (wrapper && item.contains(wrapper)) {
      const popover = wrapper.closest('quantity-popover');

      const control =
        popover && item.contains(popover)
          ? popover
          : wrapper;

      if (!column.contains(control)) {
        column.appendChild(control);
      }
    }
  }

  updateProductBlocks() {
    this.querySelectorAll('.cart-item').forEach((item) => {
      const name = item.querySelector('.cart-item__name');
      const details = item.querySelector('.cart-item__details');

      if (
        !name ||
        !details ||
        this.nvIsWellnessLink(name) ||
        this.nvIsGiftCardLink(name) ||
        !/nurevia/i.test(name.textContent)
      ) {
        return;
      }

      if (!item.hasAttribute('data-nv-product')) {
        item.setAttribute('data-nv-product', '');
        item.dataset.nvOriginalName = name.textContent.trim();
      }

      this.hideOfferOptions(details);

      const fullName =
        'Nurevia – Cápsulas Premium de Triple Acción para la Movilidad';

      if (name.textContent !== fullName) {
        name.textContent = fullName;
      }

      let subtitle = details.querySelector(
        '[data-nv-product-subtitle]'
      );

      if (!subtitle) {
        subtitle = document.createElement('p');
        subtitle.setAttribute('data-nv-product-subtitle', '');
        name.insertAdjacentElement('afterend', subtitle);
      }

      let row = details.querySelector('[data-nv-product-prices]');

      if (!row) {
        row = document.createElement('div');
        row.setAttribute('data-nv-product-prices', '');
        subtitle.insertAdjacentElement('afterend', row);
      }

      let column = row.querySelector('[data-nv-unit-column]');

      if (!column) {
        column = document.createElement('div');
        column.setAttribute('data-nv-unit-column', '');
        row.prepend(column);
      }

      let unit = row.querySelector('[data-nv-unit-price]');

      if (!unit) {
        const original = Array.from(details.children).find(
          (element) => {
            return (
              element.classList.contains('cart-item__discounted-prices') ||
              (
                element.tagName === 'DIV' &&
                element.classList.contains('product-option')
              )
            );
          }
        );

        if (original) {
          unit = document.createElement('div');
          unit.setAttribute('data-nv-unit-price', '');
          column.prepend(unit);

          original.setAttribute('data-nv-original-unit', '');
          unit.appendChild(original);

          const label = document.createElement('span');
          label.setAttribute('data-nv-unit-label', '');
          label.textContent = 'c/u';
          unit.appendChild(label);
        }
      } else if (unit.parentElement !== column) {
        column.prepend(unit);
      }

      const originalPrice = unit?.querySelector(
        '[data-nv-original-unit]'
      );

      const bottles = this.detectOffer(item, originalPrice);

      const subtitleText = bottles
        ? `60 cápsulas por frasco | ${bottles} unidades`
        : '60 cápsulas por frasco';

      if (subtitle.textContent !== subtitleText) {
        subtitle.textContent = subtitleText;
      }

      if (unit) {
        const value = {
          1: '$24.990',
          2: '$19.995',
          3: '$16.663'
        }[bottles];

        let offer = unit.querySelector('[data-nv-offer-price]');

        if (value) {
          if (!offer) {
            offer = document.createElement('span');
            offer.setAttribute('data-nv-offer-price', '');
            unit.prepend(offer);
          }

          if (offer.textContent !== value) {
            offer.textContent = value;
          }

          if (originalPrice) originalPrice.hidden = true;
        } else {
          offer?.remove();

          if (originalPrice) originalPrice.hidden = false;
        }
      }

      const total = item.querySelector(
        '.cart-item__totals .cart-item__price-wrapper'
      );

      if (total) {
        if (!total.querySelector('[data-nv-total-label]')) {
          const label = document.createElement('span');
          label.setAttribute('data-nv-total-label', '');
          label.textContent = 'Total';
          total.prepend(label);
        }

        if (total.parentElement !== row) row.appendChild(total);
      }

      this.positionQuantity(item, column);
    });
  }

  bindOverlay() {
    const overlay = this.querySelector('#CartDrawer-Overlay');

    if (!overlay || overlay.dataset.nvCloseBound) return;

    overlay.dataset.nvCloseBound = 'true';
    overlay.addEventListener('click', this.close.bind(this));
  }

  // Detecta una apertura real, incluso si una app añade "active".
  syncReservationState() {
    const isOpen = this.classList.contains('active');
    const justOpened = isOpen && !this.reservationWasOpen;

    this.reservationWasOpen = isOpen;

    if (!isOpen || !this.hasCartProducts()) {
      this.hideReservation();
      this.timerEnd = null;
      return;
    }

    if (justOpened || this.timerEnd === null) {
      this.startReservation();
    } else {
      this.renderReservation();
    }
  }

  // Crea un plazo nuevo y un único intervalo.
  startReservation() {
    if (
      !this.classList.contains('active') ||
      !this.hasCartProducts()
    ) {
      this.hideReservation();
      this.timerEnd = null;
      return;
    }

    clearInterval(this.timerInterval);
    this.timerInterval = null;
    this.timerEnd = Date.now() + 10 * 60 * 1000;

    this.renderReservation();

    this.timerInterval = setInterval(() => {
      this.renderReservation();
    }, 1000);
  }

  hideReservation() {
    this.querySelectorAll('[data-nv-reservation]').forEach((block) => {
      block.remove();
    });

    clearInterval(this.timerInterval);
    this.timerInterval = null;
  }

  renderReservation() {
    if (
      !this.classList.contains('active') ||
      !this.hasCartProducts()
    ) {
      this.hideReservation();
      return;
    }

    if (this.timerEnd === null) return;

    const remaining = Math.max(
      0,
      Math.ceil((this.timerEnd - Date.now()) / 1000)
    );

    if (!remaining) {
      // Conserva el plazo vencido hasta cerrar el carrito.
      this.hideReservation();
      return;
    }

    const inner = this.querySelector('.drawer__inner');
    if (!inner) return;

    const header = inner.querySelector('.drawer__header');

    if (!header) {
      this.hideReservation();
      return;
    }

    let block = inner.querySelector('[data-nv-reservation]');

    // Conserva únicamente un bloque.
    this.querySelectorAll('[data-nv-reservation]').forEach((existing) => {
      if (existing !== block) existing.remove();
    });

    if (!block) {
      block = document.createElement('div');
      block.setAttribute('data-nv-reservation', '');

      block.innerHTML = `
        <span>Carrito reservado por</span>
        <span data-nv-clock role="timer" aria-live="off"></span>
      `;

      let anchor = header;

      while (
        anchor.parentElement &&
        anchor.parentElement !== inner
      ) {
        anchor = anchor.parentElement;
      }

      anchor.insertAdjacentElement('afterend', block);
    }

    const clock = block.querySelector('[data-nv-clock]');

    const value =
      `${String(Math.floor(remaining / 60)).padStart(2, '0')}:` +
      `${String(remaining % 60).padStart(2, '0')}`;

    if (clock && clock.textContent !== value) {
      clock.textContent = value;
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  removeFocusTransitionHandler() {
    if (!this.focusTransitionHandler) return;

    this.removeEventListener(
      'transitionend',
      this.focusTransitionHandler
    );

    this.focusTransitionHandler = null;
  }

  open(triggeredBy) {
    if (triggeredBy) {
      this.setActiveElement(triggeredBy);
    }

    clearTimeout(this.openTimeout);
    this.removeFocusTransitionHandler();

    this.refreshCartLayout();

    const cartDrawerNote = this.querySelector(
      '[id^="Details-"] summary'
    );

    if (
      cartDrawerNote &&
      !cartDrawerNote.hasAttribute('role')
    ) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    this.focusTransitionHandler = (event) => {
      if (
        !this.classList.contains('active') ||
        event.target !== this.querySelector('.drawer__inner')
      ) {
        return;
      }

      const container = this.classList.contains('is-empty')
        ? this.querySelector('.drawer__inner-empty')
        : this.querySelector('#CartDrawer');

      const focus =
        this.querySelector('.drawer__inner') ||
        this.querySelector('.drawer__close');

      if (container && focus) {
        trapFocus(container, focus);
      }

      this.removeFocusTransitionHandler();
    };

    this.addEventListener(
      'transitionend',
      this.focusTransitionHandler
    );

    this.openTimeout = setTimeout(() => {
      this.openTimeout = null;
      this.classList.add('animate', 'active');

      this.refreshCartLayout();
      this.syncReservationState();

      const items = this.querySelector('cart-drawer-items');

      items?.updateCartUpsellToggleState?.();
      items?.updateCartUpsellVisibility?.();
    });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    clearTimeout(this.openTimeout);
    this.openTimeout = null;

    this.removeFocusTransitionHandler();
    this.classList.remove('active', 'animate');

    this.reservationWasOpen = false;
    this.timerEnd = null;
    this.hideReservation();

    document.body.classList.remove('overflow-hidden');
    removeTrapFocus(this.activeElement);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling?.id) {
      cartDrawerNote.setAttribute(
        'aria-controls',
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      );
    });

    cartDrawerNote.parentElement.addEventListener(
      'keyup',
      onKeyUpEscape
    );
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner')?.classList.remove('is-empty');
    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const element = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      element.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    this.nvRememberCart(parsedState);
    this.refreshCartLayout();
    this.bindOverlay();
    this.syncReservationState();
    this.observer?.takeRecords();
    if (!this.nvProtectionRendering && !this.classList.contains('active')) this.open();
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const documentHTML = new DOMParser().parseFromString(
      html,
      'text/html'
    );

    documentHTML.querySelectorAll(
      'cart-drawer .drawer__heading, #CartDrawer .drawer__heading'
    ).forEach((heading) => {
      heading.textContent = 'TU CARRITO';
    });

    return documentHTML.querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const documentHTML = new DOMParser().parseFromString(
      html,
      'text/html'
    );

    documentHTML.querySelectorAll(
      '#CartDrawer .drawer__heading'
    ).forEach((heading) => {
      heading.textContent = 'TU CARRITO';
    });

    return documentHTML.querySelector(selector).innerHTML;
  }
}

if (!customElements.get('cart-drawer-items')) customElements.define('cart-drawer-items', CartDrawerItems);
})();
